import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TRule } from 'utils'

interface IValidationsState {
  validationRules: Record<string, TRule>
}

const initialState: IValidationsState = {
  validationRules: {},
}

const validationsSlice = createSlice({
  name: 'validations',
  initialState,
  reducers: {
    setValidationRules: (
      state,
      action: PayloadAction<Record<string, TRule>>
    ) => {
      state.validationRules = action.payload || {}
    },
  },
})

export const { setValidationRules } = validationsSlice.actions

export default validationsSlice.reducer
